import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { ToastProvider } from '@/components/ui/toast';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Analysis from '@/pages/Analysis';
import AIAnalysis from '@/pages/AIAnalysis';
import CrossAnalysis from '@/pages/CrossAnalysis';
import FunnelAnalysis from '@/pages/FunnelAnalysis';
import URLClickAnalysis from '@/pages/URLClickAnalysis';
import Scoring from '@/pages/Scoring';
import InflowAnalysis from '@/pages/InflowAnalysis';
import Conversion from '@/pages/Conversion';
import Settings from '@/pages/Settings';
import MyCompany from '@/pages/MyCompany';
import Companies from '@/pages/admin/Companies';
import Users from '@/pages/admin/Users';
import Scraping from '@/pages/admin/Scraping';
import Automation from '@/pages/admin/Automation';
import LabelManagement from '@/pages/LabelManagement';
import Help from '@/pages/Help';
import Notifications from '@/pages/Notifications';
import Reports from '@/pages/Reports';
import Prediction from '@/pages/Prediction';
import SegmentAnalysis from '@/pages/SegmentAnalysis';
import Insights from '@/pages/Insights';
import SuccessCases from '@/pages/SuccessCases';
import Layout from '@/components/layout/Layout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((state) => state.user);

  if (user?.role !== 'super_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <ToastProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/analysis" element={<Analysis />} />
                <Route path="/cross-analysis" element={<CrossAnalysis />} />
                <Route path="/funnel-analysis" element={<FunnelAnalysis />} />
                <Route path="/url-click-analysis" element={<URLClickAnalysis />} />
                <Route path="/scoring" element={<Scoring />} />
                <Route path="/inflow-analysis" element={<InflowAnalysis />} />
                <Route path="/conversion" element={<Conversion />} />
                <Route path="/ai-analysis" element={<AIAnalysis />} />
                <Route path="/my-company" element={<MyCompany />} />
                <Route path="/labels" element={<LabelManagement />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/prediction" element={<Prediction />} />
                <Route path="/segment-analysis" element={<SegmentAnalysis />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/success-cases" element={<SuccessCases />} />
                <Route path="/help" element={<Help />} />
                {/* 旧ルートからのリダイレクト */}
                <Route path="/data-table" element={<Navigate to="/analysis" replace />} />
                <Route path="/click-rate" element={<Navigate to="/analysis" replace />} />
                <Route path="/sales" element={<Navigate to="/analysis" replace />} />

                {/* 管理者専用ルート */}
                <Route
                  path="/admin/companies"
                  element={
                    <AdminRoute>
                      <Companies />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/users"
                  element={
                    <AdminRoute>
                      <Users />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/scraping"
                  element={
                    <AdminRoute>
                      <Scraping />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/automation"
                  element={
                    <AdminRoute>
                      <Automation />
                    </AdminRoute>
                  }
                />

                {/* 404 */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
      </Routes>
    </ToastProvider>
  );
}

export default App;
